<template>
  <div>
    <div class="form-inline">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="版本类型">
            <el-select
              size="small"
              v-model="formInline.versionType"
              placeholder="请选择版本类型"
            >
              <el-option
                v-for="item in versionTypes"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号">
            <el-input
              size="small"
              v-model="formInline.version"
              placeholder="请输入版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="固件分区">
            <el-select
              size="small"
              v-model="formInline.firmArea"
              placeholder="请选择固件分区"
            >
              <el-option label="A" value="A"></el-option>
              <el-option label="B" value="B"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目">
            <el-select
              size="small"
              filterable
              v-model="formInline.projectId"
              v-el-select-loadmore="loadMore"
              placeholder="请选择所属项目"
            >
              <el-option
                v-for="item in project.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="success" plain @click="onQuery">查询</el-button>
            <el-button plain @click="onReset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="recordId"
        label="记录ID"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="deviceSn"
        label="设备SN号"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column prop="msgId" label="消息id" align="center" width="240">
      </el-table-column>
      <el-table-column prop="msgCode" label="消息码" align="center" width="80">
      </el-table-column>
      <el-table-column prop="msgContent" label="消息内容" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            :content="row.msgContent"
            placement="top-start"
            :open-delay="300"
            :hide-delay="800"
            :enterable="true"
          >
            <div class="text-ellipsis">
              {{ row.msgContent }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="direction"
        label="消息方向"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column prop="creator" label="发出者" align="center" width="160">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="160"
      >
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNo"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="formInline.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpgradeRecord",
  data() {
    return {
      versionTypes: [],
      project: {
        total: 0,
        list: [],
        pageNo: 1
      },
      tableData: [],
      formInline: {
        versionType: "",
        version: "",
        firmArea: "",
        projectId: "",
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          if (scrollHeight - scrollTop == clientHeight) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getVersionType() {
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/versionType",
        method: "GET",
        callback: response => {
          this.versionTypes = response;
        }
      });
    },
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));

          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    getRecordList() {
      const data = {
        versionType: this.formInline.versionType,
        version: this.formInline.version,
        firmArea: this.formInline.firmArea,
        projectId: this.formInline.projectId,
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/record/page",
        data: data,
        method: "GET",
        callback: response => {
          this.tableData = response.list;
          this.formInline.total = response.count;
          this.formInline.pageNo = response.pageNo;
          this.formInline.pageSize = response.pageSize;
        }
      });
    },

    onQuery() {
      this.getRecordList();
    },

    handleCurrentChange(pageNo) {
      console.log("pageNo", pageNo);
      this.formInline.pageNo = pageNo;
      this.getRecordList(); // 刷新列表
    },

    handleSizeChange(pageSize) {
      this.formInline.pageSize = pageSize;
      this.getRecordList(); // 刷新列表
    },

    onReset() {
      this.formInline.versionType = "";
      this.formInline.version = "";
      this.formInline.firmArea = "";
      this.formInline.projectId = "";
    }
  },
  beforeMount() {
    // console.log("beforeMount!");
    this.getVersionType();
    this.getProjects(this.project.pageNo);
    this.getRecordList();
  } //生命周期 - 挂载之前
};
</script>

<style lang="less" scoped>
.form-inline {
  border-bottom: 1px solid #dcdfe6;
}
.demo-form-inline {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
.btn-group {
  margin: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  /deep/ .el-pagination {
    padding: 0;
  } /* 其他样式 */
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/otaManager/record.vue